import Modal from "../classes/modal";
import Swal from 'sweetalert2/dist/sweetalert2.js';
const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function InitBundleGenerator() {
    const buttonGenerate = document.getElementById('button-generate');
    if (!buttonGenerate) 
        return;

    buttonGenerate.addEventListener('click', () => {
        new Modal({
            showLoading: true
        }).show();

        generateBundle((data) => {
            Swal.fire({
                icon: 'success', 
                title: 'Bundle erfolgreich generiert 🎉',
                confirmButtonText: 'Nice!',
                html: `
                    <a href="${ data.url }" target="_blank">${ data.url }</a>
                    <button id="copy-bundle-url">
                        <span class="button-underline">URL kopieren</span>
                        <img src="/svg/clipboard.svg" class="icon">
                        <span class="copy-result hidden">✔️</span>
                    </button>`
            });

            const buttonCopy = document.getElementById('copy-bundle-url');
            buttonCopy.addEventListener('click', () => {
                copyUrl(data.url);
                buttonCopy.querySelector('.copy-result').classList.remove('hidden');
            });
        });
    });
}

function copyUrl(url) {
    var dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.value = url;
    dummy.select();
    dummy.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(dummy);
}

function generateBundle(callback) {
    const modules = Array
        .from(document.querySelectorAll('input[name="modules[]"]'))
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);

    axios({
        method: 'POST',
        url: '/starter-kits/bundles/generate',
        data: { modules: modules },
    })
        .then((response) => {
            if(typeof callback === 'function') 
                callback(response.data);
        })
        .catch((error) => {
            new Modal({ 
                icon: 'error', 
                text: 'Leider ist bei der Erstellung des Bundles ein Fehler aufgetreten. 😔'
            }).show();
        });
}
